var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKpiCapturesPerDayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 10C5.83333 12.3 7.7 14.1667 10 14.1667C12.3 14.1667 14.1667 12.3 14.1667 10C14.1667 7.7 12.3 5.83333 10 5.83333C7.7 5.83333 5.83333 7.7 5.83333 10ZM10 7.5C11.375 7.5 12.5 8.625 12.5 10C12.5 11.375 11.375 12.5 10 12.5C8.625 12.5 7.5 11.375 7.5 10C7.5 8.625 8.625 7.5 10 7.5ZM4.16667 4.16667H7.5V2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V7.5H4.16667V4.16667ZM4.16667 17.5H7.5V15.8333H4.16667V12.5H2.5V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5ZM17.5 12.5H15.8333V15.8333H12.5V17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V12.5ZM15.8333 7.5H17.5V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5H12.5V4.16667H15.8333V7.5Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiCapturesPerDayIcon);
export default __webpack_public_path__ + "static/media/kpi_captures_per_day_icon.68684ddd0e7f9daeb40ba60a5750207f.svg";
export { ForwardRef as ReactComponent };